export default "__VITE_ASSET__650f4ed9__"